import { compose } from "redux";
import React, { PureComponent } from "react";

import { Format } from "app/app.constants";
import { formatDate } from "utils/format.util";
import WorkScheduleReportHeaderBase from "features/planner/report/workSchedule/components/WorkScheduleReportHeaderBase";
import WorkScheduleMonthReportHeaderDay from "features/planner/report/workSchedule/components/month/WorkScheduleMonthReportHeaderDay";

class WorkScheduleMonthReportHeader extends PureComponent {
  renderDate = (date, index) => {
    return (
      <WorkScheduleMonthReportHeaderDay
        key={index}
        date={date}
        title={formatDate(date, Format.workSchedule)}
      />
    );
  };

  render() {
    const { dates, title } = this.props;

    return (
      <WorkScheduleReportHeaderBase
        dates={dates}
        title={title}
        renderDate={this.renderDate}
      />
    );
  }
}

export default compose()(WorkScheduleMonthReportHeader);
